import React, { useEffect, useState } from "react";
import { Button, Col, Divider, Form, Input, Layout, Row, Typography, Select, Alert, notification, Switch, Table, Space } from 'antd';
import { CaretLeftOutlined, CaretRightOutlined, PlusOutlined, SearchOutlined } from '@ant-design/icons';
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { inject, observer } from 'mobx-react'

import "./style.scss";
import { cloneDeep } from "lodash";

const { Content } = Layout;
const { Title, Text } = Typography;
const { TextArea } = Input;

const AddCoreLeaderInvite = ({ organizationStore, voterStore }) => {

    const [form] = Form.useForm();
    const navigate = useNavigate();

    const [selectedVoter, setSelectedVoter] = useState()
    const [searchName, setSearchName] = useState();
    
    useEffect(() => {
        if(selectedVoter) {
            form.setFieldsValue(selectedVoter)
        }
    }, [selectedVoter])

    useEffect(() => {
        voterStore.page = 1;
        voterStore.hasMore = false;
        voterStore.perPage = 5;
        voterStore.fetchVoters();
    }, [])

    const handlePrevPage = () => {
        voterStore.page = voterStore.page - 1;
        if(searchName){
            voterStore.searchVoters(searchName);
        }else{
            voterStore.fetchVoters();
        }
        
    };

    const handleNextPage = () => {
        voterStore.page = voterStore.page + 1;
        if(searchName){
            voterStore.searchVoters(searchName);
        }else{
            voterStore.fetchVoters();
        }
    };

    const handleSearchVoter = () => {
        if (!searchName){
            notification.error({
                top: 120,
                message: 'Error!',
                description: 'Please provide a Voter Name'
            });
            return;
        } else if(searchName == ""){
            notification.error({
                top: 120,
                message: 'Error!',
                description: 'Please provide a Voter Name'
            });
            return;
        } else{
            voterStore.searchVoters(searchName);
        }
    };

    const handleSubmitNewTeamLeader = (values) => {
        const teamLeaderDataPost = {
            fullName: values.FullName,
            address: values.Address,
            contactNumber: values.ContactNumber,
            username: values.Username,
            password: values.Password,
            remarks: values.Remarks,
            votersID: selectedVoter ? selectedVoter.VIN : "Not Available",
        };

        Swal.fire({
            title: "Add New to Invite",
            icon: "question",
            text: "Are you sure do you want to add this user?",
            showCancelButton: true,
            confirmButtonText: "Yes",
            cancelButtonText: `Cancel`
        }).then((result) => {
            if (result.isConfirmed) {
               organizationStore.createNewMember(teamLeaderDataPost);
            } 
        })
    }

    const columns = [
        {
          title: 'Name',
          key: 'FullName+ID',
          dataIndex: 'FullName',
          render: (FullName) => (
            <Text default>{FullName}</Text>
          )
        },
        {
          title: 'Precinct',
          key: 'Precint+ID',
          dataIndex: 'Precint',
          render: (Precint) => (
            <Text default>{Precint}</Text>
          )
        },
        {
          title: 'Street',
          key: 'Street+ID',
          dataIndex: 'Street',
          render: (Street) => (
            <Text default>{Street}</Text>
          )
        },
        {
          title: 'Address',
          key: 'Address+ID',
          dataIndex: 'Address',
          render: (Address) => (
            <Text default>{Address}</Text>
          )
        },
        {
          title: 'Action',
          dataIndex: 'action',
          key: 'action',
          fixed: "right",
          render: (text, record) => (
            <Space size={'small'}>
                <Button 
                    type="primary" 
                    ghost
                    onClick={() => setSelectedVoter(record)}
                >Select</Button>
            </Space>
          )
        },
    ];

    return (
        <div className="admin-add-team-leader">
            <Content>
                <div className="admin-add-team-leader-content">
                    <Title level={5}><SearchOutlined /> Search to Invite from Voters</Title>
                    <Row gutter={10}>
                        <Col>
                            <Input
                                placeholder="Enter name"
                                allowClear
                                value={searchName}
                                onChange={(e) => setSearchName(e.target.value)}
                            />
                        </Col>
                        <Col>
                            <Button type="primary" icon={<SearchOutlined />} onClick={handleSearchVoter}>Search to Invite</Button>
                        </Col>
                    </Row>
                    <Divider/>
                    <Table pagination={false} columns={columns} dataSource={voterStore.voters} scroll={{ x: "max-content" }} bordered/>
                    <ul className="pagination">
                        <li className="pagination-prev "><Button type="dashed" onClick={handlePrevPage} disabled={voterStore.page == 1 ? true : false}><CaretLeftOutlined />Prev</Button></li>
                        <li className="pagination-item"><a>{voterStore.page}</a></li>
                        <li className="pagination-next "><Button type="dashed" onClick={handleNextPage} disabled={voterStore.hasMore ? false : true}>Next<CaretRightOutlined /></Button></li>
                    </ul>
                </div>
            </Content>
            <Content>
                <Form 
                    name="addbillingInformationForm"
                    layout="vertical"
                    form={form} 
                    onFinish={handleSubmitNewTeamLeader}
                >
                    <div className="admin-add-team-leader-content">
                        <Title level={4}>Add to Invite</Title>
                        <Divider />
                        <Row justify={'center'} gutter={10}>
                            <div className="form-container">
                                <Title level={5}>Basic Information</Title>
                                <Row gutter={10}>
                                    <Col span={24}>
                                        <Form.Item
                                            label="Full Name"
                                            name="FullName"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: 'Please input Full Name.',
                                                },
                                            ]}
                                        >
                                            <Input placeholder="Enter Full Name"/>
                                        </Form.Item>
                                    </Col>
                                    
                                    <Col span={24}>
                                        <Form.Item
                                            label="Address"
                                            name="Address"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: 'Please input Address.',
                                                },
                                            ]}
                                        >
                                            <TextArea placeholder="Enter Address"/>
                                        </Form.Item>
                                    </Col>
                                    <Divider/>
                                    <Col span={12}>
                                        <Form.Item
                                            label="Contact #"
                                            name="ContactNumber"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: 'Please input Contact #.',
                                                },
                                            ]}
                                        >
                                            <Input placeholder="Enter Contact #"/>
                                        </Form.Item>
                                    </Col>
                                    <Col span={24}>
                                        <Form.Item
                                            label="Add Remarks"
                                            name="Remarks"
                                        >
                                            <TextArea placeholder="Add leader remarks..."/>
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Title level={5}>Account Information</Title>
                                <Row gutter={10}>
                                    <Col span={12}>
                                        <Form.Item
                                            label="Username"
                                            name="Username"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: 'Please input Username.',
                                                },
                                            ]}
                                        >
                                            <Input placeholder="Enter Username"/>
                                        </Form.Item>
                                    </Col>
                                    <Col span={12}>
                                        <Form.Item
                                            label="Password"
                                            name="Password"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: 'Please input Password.',
                                                },
                                            ]}
                                        >
                                            <Input.Password placeholder="Enter Password"/>
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </div>
                        </Row>
                        <Divider/>
                        <Row justify={'end'} gutter={12}>
                            <Col>
                                <Button type="primary" htmlType="submit" icon={<PlusOutlined/>} loading={voterStore.loading}>Submit</Button>
                            </Col>
                            <Col>
                                <Button onClick={() => navigate(-1)} loading={voterStore.loading}>Back</Button>
                            </Col>
                        </Row>
                    </div>
                </Form>
            </Content>
        </div>
    );
};

export default inject('organizationStore', 'voterStore')(observer(AddCoreLeaderInvite));
